<template>

    <div id="service-provider-registration-form" class="pt-9 pb-7">
        <div class="container text-default">
            <h2 class="text-default display-4 montserrat-bold text-uppercase mb-3">
                Be a Cutiefy Accredited Service Provider
            </h2>
            <p class="font-weight-400 mb-4">
                If you are a registered beauty service provider (salon, spa, aesthetic clinic or wellness center) who has been in operation for at least a year and employing at least 3 salon personnel, we invite you to join our family.
            </p>
            <p class="font-weight-400 mb-5">
                Please fill-in form below and a Cutiefy representative will contact you to arrange for a visit to your salon
            </p>
            <h2 class="text-default display-5 montserrat-bold text-uppercase mb-3">
                Application for accreditation
            </h2>

            <card-stepper-wrapper :items="steps" ref="stepperWrapper">
                <template slot="body" slot-scope="{ activeItem }">
                    <applicant-section v-if="activeItem.id == 'applicant-section'" 
                        @next="submitApplicantInfo"
                    />

                    <basic-info-section v-else-if="activeItem.id == 'basic-info-section'" 
                        @next="submitBasicInfo"
                        @back="() => moveStepperTo(0)"
                    />

                    <address-section v-else-if="activeItem.id == 'address-section'" 
                        @next="submitAddressInfo"
                        @back="() => moveStepperTo(1)"
                    />

                    <business-info-section v-else-if="activeItem.id == 'business-info-section'" :business-type="data.shop_type" 
                        @next="submitBusinessInfo"
                        @back="() => moveStepperTo(2)"
                    />
                    
                    <confirmation-section v-else-if="activeItem.id == 'confirmation'"
                        @submit="submit"
                        @back="() => moveStepperTo(3)"
                    />
                </template>
            </card-stepper-wrapper>

        </div>
    </div>
</template>

<script>
import mixins from "@utils/mixins";
import ApplicantSection from "./partials/ApplicantSection";
import BasicInfoSection from "./partials/BasicInfoSection";
import AddressSection from "./partials/AddressSection";
import OwnerInfoSection from "./partials/OwnerInfoSection";
import BusinessInfoSection from "./partials/BusinessInfoSection";
import ConfirmationSection from "./partials/ConfirmationSection";

import CardStepperWrapper from "@components/containers/cards/card-stepper/CardStepperWrapper";

import { registerApplicant } from "./helpers";

export default {
    name: "PartnerRegistrationPage",

    components: {
        ApplicantSection, BasicInfoSection, AddressSection, OwnerInfoSection,
        BusinessInfoSection, CardStepperWrapper, ConfirmationSection
    },
    
    data: () => ({
        isRequesting: false,
        steps: [
            { id: "applicant-section", title: "Applicant Information" },
            { id: "basic-info-section", title: "Company Basic Information" },
            { id: "address-section", title: "Company Address Information" },
            { id: "business-info-section", title: "Company Business Information" },
            { id: "confirmation", title: "Confirmation" },
        ],
        data: {},
    }),

    methods: {
        initializeSteppers() {
            this.moveStepperTo(0);
        },

        moveStepperTo(index) {
            this.$refs.stepperWrapper.setItem(index);
            window.scroll(0, 0);
        },

        returnToApplicantInfo() {
            this.moveStepperTo(0);
        },

        submitApplicantInfo(data) {
            this.data.firstname = data.firstname;
            this.data.middlename = data.middlename;
            this.data.lastname = data.lastname;
            this.data.is_owner = data.is_owner;
            this.data.contact_no = data.contact_no;
            this.data.email = data.email;
            this.data.referrer_name = data.referrer_name;
            
            this.moveStepperTo(1);
        },

        submitBasicInfo(data) {
            this.data.shop_name = data.shop_name;
            this.data.shop_type = data.shop_type;
            this.data.shop_mobile_no = data.shop_mobile_no;
            this.data.shop_landline_no = data.shop_landline_no;
            this.data.shop_email = data.shop_email;
            this.data.shop_website = data.shop_website;

            this.moveStepperTo(2);
        },

        submitAddressInfo(data) {
            this.data.specification = data.specification;
            this.data.barangay = data.barangay;
            this.data.city = data.city;
            this.data.province = data.province;
            this.data.country = data.country;
            this.data.zipcode = data.zipcode;
            this.data.latitude = data.latitude;
            this.data.longitude = data.longitude;
            this.data.place_id = data.place_id;

            this.moveStepperTo(3);
        },

        submitOwnerInfo(data) {
            this.data.owner_lastname = data.owner_lastname;
            this.data.owner_firstname = data.owner_firstname;
            this.data.owner_middlename = data.owner_middlename;
            this.data.principals = data.principals;

            this.moveStepperTo(4);
        },

        submitBusinessInfo(data) {
            this.data.owner_lastname = data.owner_lastname;
            this.data.owner_firstname = data.owner_firstname;
            this.data.owner_middlename = data.owner_middlename;
            this.data.principals = data.principals;
            this.data.owner_lastname = data.owner_lastname;
            this.data.employee_count = data.employee_count;
            this.data.metropolitant_branch_count = data.metropolitant_branch_count;
            this.data.provincial_branch_count = data.provincial_branch_count;
            this.data.franchised_metropolitant_branch_count = data.franchised_metropolitant_branch_count;
            this.data.franchised_provincial_branch_count = data.franchised_provincial_branch_count;
            this.data.register_all_branches = data.register_all_branches;
            this.data.register_branches_count = data.register_branches_count;
            this.data.has_booking_system = data.has_booking_system;
            this.data.duration_of_booking_system_use = data.duration_of_booking_system_use;
            this.data.booking_system_remark = data.booking_system_remark;
            this.data.serivces_offered = data.serivces_offered;
            this.data.has_home_service = data.has_home_service;
            this.data.home_serivces_offered = data.home_serivces_offered;
            this.data.home_serivces_area = data.home_serivces_area;
            this.data.certificate_of_registration = data.certificate_of_registration;
            this.data.business_permit = data.business_permit;
            this.data.owner_id = data.owner_id;

            this.moveStepperTo(4);
        },

        submit(data) {
            this.isRequesting = true;
            console.log(this.data);
            registerApplicant(this.data)
                .then(response => this.saved(response))
                .catch(error => this.presentError(error))
                .finally(() => this.isRequesting = false);
        },

        saved(response) {
            this.promptMessage(response.data.message.message, "Thank you for your interest. We shall review your application and get back to you shortly.")
                .then(() => this.$router.push({ name: 'Home' }));
        }
    },

    mixins: [mixins],

    mounted() {
        this.$nextTick(() => this.initializeSteppers())
    }
}
</script>

<style scoped lang="css">
    .features-section {
        margin-top: 30px
    }
    .features-section .icon-bullet-icon {
        font-family: 'Montserrat', sans-serif;
    }
</style>